import { render, staticRenderFns } from "./FbMemberPictureGroup.vue?vue&type=template&id=24d7c75a"
import script from "./FbMemberPictureGroup.vue?vue&type=script&lang=js"
export * from "./FbMemberPictureGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports